<script>
    import DurationDisplay from '../../common/DurationDisplay.svelte';

    export let col = '';
    export let row = {};
    export let options = {};

</script>

{#if options && options.icon && options.iconClass}
<span class='icon'>
    <i class="fas {options.iconClass}"></i>
</span>
{/if}

<DurationDisplay seconds={row[col]} formatted={row.element_instances? true : false}/>
